import React from 'react';

import { Box, Grid, Link, Typography } from '@mui/material';
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';
import { COLOR_PRIMARY_1 } from 'src/utils/colors';
import { InfoButton } from 'src/App/Dashboards/Market/Components/Buttons';

export type SubsectionHeadingTooltipConfig = {
  definitionLines: readonly string[];
  learnMoreLinkText: string;
  ctaUrl: string;
};

const SubsectionHeading = ({
  title,
  sourceTag,
  tooltipConfig,
}: {
  title: string;
  sourceTag?: string;
  tooltipConfig?: SubsectionHeadingTooltipConfig;
}) => (
  <Grid container item xs={12} direction="row" alignItems="center" justifyContent="space-between" gap={0.5}>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <Typography variant="h2" sx={{ color: COLOR_PRIMARY_1, fontWeight: 400 }}>
        {title}
      </Typography>
      {tooltipConfig && (
        <InfoButton
          tooltipContent={
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
              {tooltipConfig.definitionLines.map((line, i) => (
                <Typography key={i} variant="body2" sx={{ fontWeight: 500 }}>
                  {line}
                </Typography>
              ))}
              <Link
                href={tooltipConfig.ctaUrl}
                target="_blank"
                rel="noreferrer"
                sx={{ fontWeight: 'bold', display: 'inline-flex', alignItems: 'center', gap: 0.5, mt: 0.5 }}
              >
                {tooltipConfig.learnMoreLinkText}
                <OpenInNewRoundedIcon sx={{ fontSize: 14 }} />
              </Link>
            </Box>
          }
        />
      )}
    </Box>
    {sourceTag && (
      <Typography
        variant="caption"
        sx={{ color: COLOR_PRIMARY_1, fontWeight: 400, fontStyle: 'italic' }}
      >
        *{sourceTag}
      </Typography>
    )}
  </Grid>
);

export default SubsectionHeading;
